import axios from './ApiService'

export default {
    postToChannel
}

async function postToChannel(postContent: any) {
    let result = 
    await axios.post('content', postContent, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return {
        result: result.data.result,
        errors: result.data.errors,
        type : result.data.type
    };
}